<script>
export default {
  name: "UserEditModal",
  props: {
    modal: { type: Boolean, default: () => false },
    user: { type: Object, default: () => null },
    groupOption: { type: Array, default: () => [] },
  },
  data() {
    return {
      form: {
        site_group: null,
      },
    };
  },
};
</script>

<template>
  <div id="user-edit-modal">
    <v-dialog v-model="modal" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">ユーザー情報の編集</span>
        </v-card-title>
        <v-card-text>
          <v-form refs="form">
            <v-row>
              <v-col cols="12">
                <v-select
                  label="所属グループ"
                  v-model="form.site_group"
                  :items="groupOption"
                  item-text="name"
                  item-value="id"
                  return-object
                  required
                >
                </v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="$emit('close')" text>閉じる</v-btn>
          <v-btn class="submit" @click="$emit('submit', form.site_group)" text
            >更新する</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
